import { render } from "./DescendantTreePersonCards.vue?vue&type=template&id=5e095635"
import script from "./DescendantTreePersonCards.vue?vue&type=script&lang=js"
export * from "./DescendantTreePersonCards.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__